module.exports = __webpack_public_path__ + "img/m-churukubaobiao.20696ae4.svg";